import { scrollToElement } from "./Util";

/* Анкоры  */

/**
 * ссыла в формате <a href="#anchor_name" class="js-anchor"></a>
 * **/

$('.js-anchor').on('click', function () {
    let id = $(this).attr('href');

    scrollToElement($(`${id}`));
});


// WEBPACK FOOTER //
// ./_src/js/Anchors.js